document.addEventListener('DOMContentLoaded', () => {
  const navContainer = document.querySelector('.ja-navigations');
  if (!navContainer) return;

  const DESKTOP_BREAKPOINT = 1200;
  let isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
  let activeListeners = [];
  let isInitialLoad = true;

  // --- SADECE SAYFA YÜKLENDİĞİNDE PADDING EKLE ---
  const setInitialPadding = () => {
    if (!isInitialLoad) return;
    
    const mainContent = document.getElementById('MainContent');
    if (!mainContent) return;

    const hasL3Active = navContainer.querySelector('.l3-active');
    const hasL2Active = navContainer.querySelector('.ja-navigation-dropdown.active');
    
    if (hasL3Active) {
      mainContent.style.marginTop = isDesktop ? '20px' : '35px';
    } else if (hasL2Active) {
      mainContent.style.marginTop = isDesktop ? '15px' : '20px';
    }
    
    isInitialLoad = false;
  };

  // --- HELPERS ---
  const debounce = (func, wait = 150) => {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  const normalizeUrl = (url) => {
    try {
      const urlObj = new URL(url, window.location.origin);
      let path = urlObj.pathname;
      if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
      return path.toLowerCase();
    } catch {
      return '';
    }
  };

  const moveToStart = (element, container) => {
    if (element && container && element.parentNode === container) {
      container.insertBefore(element, container.firstChild);
    }
  };

  /* Mobil görünüm aktif dalı öne taşır. Bu gerçek DOM sırasını değiştirir;
     masaüstüne dönmeden önce ilk sırayı geri yüklemezsek görsel ve klavye
     sırası mobil gezinmeden etkilenir. Menü statik üretildiği için başlangıç
     child sıralarını bir kez saklamak yeterlidir. */
  const originalOrders = new Map();
  navContainer.querySelectorAll(
    '.ja-navigations__inner, .ja-navigation-dropdown-menu__inner, .ja-navigation-grandchild-menu'
  ).forEach(container => {
    originalOrders.set(container, Array.from(container.children));
  });

  const restoreOriginalOrder = () => {
    originalOrders.forEach((children, container) => {
      children.forEach(child => {
        if (child.parentNode === container) container.appendChild(child);
      });
    });
  };

  /* --- TIKLANAN DAL HAFIZASI ---
     Ayni koleksiyon menude birden fazla yerde bulunabiliyor. Ornek:
     /collections/bitkisel-protein hem "Vegan" hem de "Sporcu" altinda
     DOGRUDAN bir L2 baglantisi (ikisi de bir alt-menunun icinde degil,
     yani her ikisinin de L3 kimligi bos; onlari ayiran sey L1 kimligi).
     Hedef sayfada URL'den hangi dalin acilacagi anlasilamaz; DOM'daki ILK
     eslesme kazandigi icin kullanici Sporcu'dan gelse bile Vegan aciliyordu.

     Not: Liquid ayni URL'yi gosteren TUM baglantilara `active` sinifini
     basiyor, ama CSS yalnizca JS'in verdigi `active-link-style`'i
     bicimlendiriyor — bu yuzden cift vurgulama olusmuyor.

     Cozum: tiklanan baglantinin dali sessionStorage'a yazilir, hedef
     sayfada ayni yola geldiysek o dal tercih edilir. URL parametresi
     BILEREK kullanilmiyor — indekslenebilir kopya URL uretir; magazada
     tarama butcesi/dizin sismesi ozellikle mucadele edilen bir konu.

     Dal kimligi menu id'leri (L2-Menu-*, L3-Menu-*) ile tutuluyor; bunlar
     ja-navigations.liquid'de menu yapisindan uretiliyor. Menu yeniden
     siralanirsa kimlik degisir, o durumda sessizce ilk eslesmeye dusulur. */
  const NAV_BRANCH_KEY = 'yipNavBranch';

  const branchIdOf = (link) => ({
    l1: link.closest('.ja-navigation-dropdown')
      ?.querySelector('.ja-navigation-dropdown-menu')?.id || '',
    l3: link.closest('.ja-navigation-sub-dropdown')
      ?.querySelector('.ja-navigation-grandchild-menu')?.id || ''
  });

  const rememberBranch = (link) => {
    const { l1, l3 } = branchIdOf(link);
    if (!l1) return;
    try {
      sessionStorage.setItem(NAV_BRANCH_KEY, JSON.stringify({
        path: normalizeUrl(link.href),
        l1: l1,
        l3: l3
      }));
    } catch {
      /* gizli mod / kota dolu: hafiza yok, ilk eslesmeye dusulur */
    }
  };

  /* Kayit kullanildiktan sonra BILEREK silinmiyor: sekme boyunca gecerli.
     Tek kullanimlik olsaydi, kullanici koleksiyondan bir urune girip geri
     dondugunde dal Vegan'a atlardi — yani kullanicinin hicbir sey
     yapmadigi bir gezinmede baglam degisirdi. Ayni URL'nin gorunmez bir
     durumun tukenmis olmasina gore farkli acilmasi da tutarsiz olurdu.
     Yol kontrolu zaten kaydin baska sayfalari etkilemesini engelliyor. */
  const readBranch = () => {
    try {
      return JSON.parse(sessionStorage.getItem(NAV_BRANCH_KEY) || 'null');
    } catch {
      return null;
    }
  };

  /* Delegasyon: initializeNavigations() yeniden baglama yapiyor ve
     activeListeners'i temizliyor; buraya bir kez baglanip o dongunun
     disinda kalmasi daha guvenli. sessionStorage yazmasi senkron
     oldugu icin gezinme baslamadan tamamlanir. */
  navContainer.addEventListener('click', (event) => {
    const link = event.target.closest(
      'a.ja-navigation-grandchild-menu__item, a.ja-navigation-dropdown-menu__item'
    );
    if (link) rememberBranch(link);
  });

  /* Alt menu (L3) butonunun aria-expanded degerini gorsel durumla esitler.
     Onceden yalnizca L1 butonlari guncelleniyordu; alt menuler gorsel olarak
     acilip kapanirken ekran okuyucular hep "kapali" duyuyordu. `active`
     sinifini degistiren HER yer bu yardimciyi cagirmali. */
  const setSubAria = (subDropdown, expanded) => {
    subDropdown.querySelector('.ja-navigation-sub-dropdown__button')
      ?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const closeAllMenus = (force = false) => {
    navContainer.querySelectorAll('.ja-navigation-dropdown').forEach(dropdown => {
      const shouldClose = force || !dropdown.classList.contains('is-locked');
      if (shouldClose) {
        dropdown.classList.remove('active', 'is-locked');
        dropdown.querySelector('.ja-navigation-dropdown__button')?.setAttribute('aria-expanded', 'false');
        const l2Menu = dropdown.querySelector('.ja-navigation-dropdown-menu');
        if (l2Menu) {
          l2Menu.style.maxHeight = '0px';
          l2Menu.classList.remove('l3-active');
          l2Menu.querySelectorAll('.ja-navigation-sub-dropdown').forEach(sub => {
            const subShouldClose = force || !sub.classList.contains('is-locked');
            if (subShouldClose) {
              sub.classList.remove('active', 'is-locked');
              setSubAria(sub, false);
            }
          });
        }
      }
    });
  };

  // --- HEIGHT DEĞERLERİ ---
  const getL2Height = () => isDesktop ? '30px' : '32px';
  const getL3Height = () => isDesktop ? '58px' : '54px';

  // --- EVENT HANDLERS ---
  const eventHandlers = {
    openL1Menu(dropdown, menu, button) {
      closeAllMenus();
      dropdown.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
      menu.style.maxHeight = getL2Height();
    },
    closeL1Menu(dropdown, menu, button) {
      if (dropdown.classList.contains('is-locked')) return;
      dropdown.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
      menu.style.maxHeight = '0px';
    },
    clickL1Desktop(e, dropdown, menu, button) {
      e.preventDefault();
      e.stopPropagation();
      const wasLocked = dropdown.classList.contains('is-locked');
      closeAllMenus(true);
      if (!wasLocked) {
        dropdown.classList.add('active', 'is-locked');
        button.setAttribute('aria-expanded', 'true');
        menu.style.maxHeight = getL2Height();
      }
    },
    clickL1Mobile(e, dropdown) {
      e.stopPropagation();
      const isAlreadyActive = dropdown.classList.contains('active');
      closeAllMenus(true);
      if (!isAlreadyActive) {
        this.openL1Menu(dropdown, dropdown.querySelector('.ja-navigation-dropdown-menu'), dropdown.querySelector('button'));
      }
    },

    openL3Menu(subDropdown, l2Menu) {
      const activeSibling = l2Menu.querySelector('.ja-navigation-sub-dropdown.active:not(.is-locked)');
      if (activeSibling && activeSibling !== subDropdown) {
        activeSibling.classList.remove('active');
        setSubAria(activeSibling, false);
      }
      subDropdown.classList.add('active');
      setSubAria(subDropdown, true);
      l2Menu.classList.add('l3-active');
      l2Menu.style.maxHeight = getL3Height();
    },
    closeL3Menu(subDropdown, l2Menu) {
      if (subDropdown.classList.contains('is-locked')) return;
      subDropdown.classList.remove('active');
      setSubAria(subDropdown, false);
      const hasActiveSibling = l2Menu.querySelector('.ja-navigation-sub-dropdown.active');
      if (!hasActiveSibling) {
        l2Menu.classList.remove('l3-active');
        l2Menu.style.maxHeight = getL2Height();
      }
    },
    clickL2Desktop(e, subDropdown) {
      e.preventDefault();
      e.stopPropagation();
      const wasLocked = subDropdown.classList.contains('is-locked');
      const l2Menu = subDropdown.closest('.ja-navigation-dropdown-menu');

      l2Menu.querySelectorAll('.ja-navigation-sub-dropdown.is-locked').forEach(sub => {
        if (sub !== subDropdown) {
          sub.classList.remove('is-locked', 'active');
          setSubAria(sub, false);
        }
      });

      if (!wasLocked) {
        subDropdown.classList.add('is-locked');
        this.openL3Menu(subDropdown, l2Menu);
      } else {
        subDropdown.classList.remove('is-locked');
        this.closeL3Menu(subDropdown, l2Menu);
      }
    },
    clickL2Mobile(e, subDropdown) {
      e.stopPropagation();
      const wasActive = subDropdown.classList.contains('active');
      const l2Menu = subDropdown.closest('.ja-navigation-dropdown-menu');
      if (wasActive) {
        this.closeL3Menu(subDropdown, l2Menu);
      } else {
        const activeSibling = l2Menu.querySelector('.ja-navigation-sub-dropdown.active');
        if (activeSibling) {
          activeSibling.classList.remove('active');
          setSubAria(activeSibling, false);
        }
        this.openL3Menu(subDropdown, l2Menu);
      }
    }
  };

  // --- INIT / BINDINGS ---
  const cleanupNavListeners = () => {
    activeListeners.forEach(({ element, event, handler }) => element.removeEventListener(event, handler));
    activeListeners = [];
  };

  const bindKeyToggle = (el, clickHandler) => {
    const keyHandler = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        clickHandler(e);
      }
    };
    el.addEventListener('keydown', keyHandler);
    activeListeners.push({ element: el, event: 'keydown', handler: keyHandler });
  };

  const initializeNavigations = () => {
    cleanupNavListeners();

    const l1Dropdowns = navContainer.querySelectorAll('.ja-navigation-dropdown');
    const l2SubDropdowns = navContainer.querySelectorAll('.ja-navigation-sub-dropdown');

    l1Dropdowns.forEach(dropdown => {
      const button = dropdown.querySelector('.ja-navigation-dropdown__button');
      const menu = dropdown.querySelector('.ja-navigation-dropdown-menu');
      if (!button || !menu) return;

      const clickHandler = isDesktop
        ? (e) => eventHandlers.clickL1Desktop(e, dropdown, menu, button)
        : (e) => eventHandlers.clickL1Mobile(e, dropdown);

      button.addEventListener('click', clickHandler);
      activeListeners.push({ element: button, event: 'click', handler: clickHandler });
      bindKeyToggle(button, clickHandler);
    });

    l2SubDropdowns.forEach(subDropdown => {
      const button = subDropdown.querySelector('button');
      const l2Menu = subDropdown.closest('.ja-navigation-dropdown-menu');
      if (!button || !l2Menu) return;

      const clickHandler = isDesktop
        ? (e) => eventHandlers.clickL2Desktop(e, subDropdown)
        : (e) => eventHandlers.clickL2Mobile(e, subDropdown);

      button.addEventListener('click', clickHandler);
      activeListeners.push({ element: button, event: 'click', handler: clickHandler });
      bindKeyToggle(button, clickHandler);
    });
  };

  const setActiveStateOnLoad = () => {
    const currentPath = normalizeUrl(window.location.href);
    if (currentPath === '' || currentPath === '/') return;

    /* find() DEGIL: ayni yol menude birden fazla dalda bulunabiliyor ve
       find() DOM'daki ilkini dondurdugu icin kullanicinin gectigi dal
       yok sayiliyordu. Tum eslesmeler toplanip tiklanan dal tercih edilir. */
    const matchingLinks = Array.from(document.querySelectorAll('.ja-navigation-grandchild-menu__item, .ja-navigation-dropdown-menu__item'))
      .filter(link => normalizeUrl(link.href) === currentPath);

    if (matchingLinks.length === 0) return;

    let activeLink = matchingLinks[0];

    if (matchingLinks.length > 1) {
      const remembered = readBranch();
      /* Yol kontrolu sart: eski bir kayit baska bir sayfada yanlis dali
         acmasin. Dogrudan/organik giriste kayit yoktur — ilk eslesme
         kullanilir, cunku secim yapacak bilgi mevcut degil. */
      if (remembered && remembered.path === currentPath) {
        const preferred = matchingLinks.find(link => {
          const { l1, l3 } = branchIdOf(link);
          return l1 === remembered.l1 && l3 === remembered.l3;
        });
        if (preferred) activeLink = preferred;
      }
    }

    activeLink.classList.add('active-link-style');
    const l1Dropdown = activeLink.closest('.ja-navigation-dropdown');
    if (!l1Dropdown) return;

    l1Dropdown.classList.add('active');
    // Gorsel acilisla birlikte erisilebilir durum da acik olmali.
    l1Dropdown.querySelector('.ja-navigation-dropdown__button')?.setAttribute('aria-expanded', 'true');
    l1Dropdown.querySelector('.ja-navigation-dropdown-menu').style.maxHeight = getL2Height();
    if (isDesktop) l1Dropdown.classList.add('is-locked');

    const subDropdown = activeLink.closest('.ja-navigation-sub-dropdown');
    if (subDropdown) {
      const l2Menu = subDropdown.closest('.ja-navigation-dropdown-menu');
      subDropdown.classList.add('active');
      setSubAria(subDropdown, true);
      l2Menu.classList.add('l3-active');
      l2Menu.style.maxHeight = getL3Height();
      if (isDesktop) subDropdown.classList.add('is-locked');

    }

    // Sayfa yüklendiğinde padding ekle
    setInitialPadding();

    if (isDesktop) return;

    const l1Container = navContainer.querySelector('.ja-navigations__inner');
    const firstItem = l1Container.firstElementChild;
    if (firstItem && firstItem !== l1Dropdown) {
      l1Container.insertBefore(l1Dropdown, firstItem.nextSibling);
    }

    if (activeLink.classList.contains('ja-navigation-grandchild-menu__item')) {
      const l3Container = activeLink.closest('.ja-navigation-grandchild-menu');
      moveToStart(activeLink, l3Container);
    }

    if (subDropdown) {
      const l2Container = subDropdown.closest('.ja-navigation-dropdown-menu__inner');
      moveToStart(subDropdown, l2Container);
    }

    if (activeLink.classList.contains('ja-navigation-dropdown-menu__item') &&
        !activeLink.closest('.ja-navigation-sub-dropdown')) {
      const l2Container = activeLink.closest('.ja-navigation-dropdown-menu__inner');
      moveToStart(activeLink, l2Container);
    }

    setTimeout(() => {
      if (l1Container) l1Container.scrollLeft = 0;

      if (subDropdown) {
        const l2ScrollContainer = subDropdown.closest('.ja-navigation-dropdown-menu__inner');
        if (l2ScrollContainer) l2ScrollContainer.scrollLeft = 0;

        const l3ScrollContainer = subDropdown.querySelector('.ja-navigation-grandchild-menu');
        if (l3ScrollContainer) l3ScrollContainer.scrollLeft = 0;
      } else if (activeLink.classList.contains('ja-navigation-dropdown-menu__item')) {
        const l2ScrollContainer = activeLink.closest('.ja-navigation-dropdown-menu__inner');
        if (l2ScrollContainer) l2ScrollContainer.scrollLeft = 0;
      }
    }, 50);
  };

  initializeNavigations();
  setActiveStateOnLoad();

  window.addEventListener('resize', debounce(() => {
    const newIsDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    if (newIsDesktop !== isDesktop) {
      isDesktop = newIsDesktop;
      closeAllMenus(true);
      restoreOriginalOrder();
      initializeNavigations();
      /* closeAllMenus aktif koleksiyonun dalini da kapatiyordu; kirilim
         gecisinde (telefon dondurme, pencere boyutlandirma) aktif dal
         kayboluyordu. Yeniden hesapla — fonksiyon idempotent: siniflar
         tekrar eklenebilir, mobil DOM tasimalari zaten bastaki ogeyi
         basa tasimak gibi no-op'a duser, setInitialPadding ise
         isInitialLoad bayragiyla zaten tek seferlik. */
      setActiveStateOnLoad();
    }
  }));

  // Menü dışına tıklayınca kapanma - blog ve kategori sayfaları hariç
  document.addEventListener('click', (e) => {
    const currentPath = window.location.pathname;
    const isBlogPage = currentPath.includes('/blogs/');
    const isCollectionPage = currentPath.includes('/collections/');
    const isHomePage = currentPath === '/' || currentPath === '';

    // Blog, kategori ve ana sayfada dışarı tıklayınca kapanmasın
    if (isBlogPage || isCollectionPage || isHomePage) return;

    if (!navContainer.contains(e.target)) closeAllMenus(true);
  });
});
